module.exports = __webpack_public_path__ + "static/media/orc_bg.b96141c8.png";